module.exports = __webpack_public_path__ + "media/stylesheets/images/recruit-9b803b9b75b0f70470d5d6c921c8a7c6.svg";